import { ApiRoutes } from "consts/enpoints/api";
import { FormSerializers, downloadFileApi, fetchApi } from "infrastructure/api";
import type { ID } from "types";
import type { FileDownloadParams, UserPreferencesRequest } from "./types";

export const getConstants = () =>
    fetchApi(ApiRoutes.GetConstants);

export const getBitsoBanks = (query = '') =>
    fetchApi(`${ApiRoutes.GetBitsoBanks}${query}`);

export const getCountries = (query = '') =>
    fetchApi(`${ApiRoutes.GetCountries}${query}`);

export const postFile = (body: FormData) =>
    fetchApi(ApiRoutes.PostFile, {
        serializer: FormSerializers.FormData,
        method: 'POST',
        body
    });

export const downloadFile = ({
    fileKey,
    fileName = fileKey
}: FileDownloadParams) =>
    downloadFileApi(ApiRoutes.GetFile(fileKey), {
        fileName
    });

export const downloadLocalFile = ({
    fileKey,
    fileName = fileKey
}: FileDownloadParams) =>
    downloadFileApi(ApiRoutes.GetLocalFile(fileKey), {
        fileName
    });

export const deleteFile = (fileKey: string) =>
    fetchApi(ApiRoutes.DeleteFile(fileKey), {
        method: 'DELETE'
    });

export const getUserPreferences = (userId: ID) =>
    fetchApi(ApiRoutes.GetUsersPreferences(userId));

export const createOrUpdateUserPreferences = ({ userId, preferences }: UserPreferencesRequest) =>
    fetchApi(ApiRoutes.PutUsersPreferences(userId), {
        method: 'PUT',
        body: {
            preferences
        }
    });
